import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the admin user view.
 * @extends JetView
 */
export default class tableAdminUserView extends JetView {
    /**
     * Configures the layout of the admin user view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [
                {
                    id: 'preloader', // Preloader ID
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            id: 'datatable', // Data table ID
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scroll: true, // Enable scrolling
                            columns: [
                                {
                                    id: 'detailTittle', // Column ID for details
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    tooltip: 'Detalles', // Tooltip text
                                    hidden: !devConfig.getPermAction('adminUserManagementButton', 'Edit'), // Conditional visibility based on permissions
                                    css: 'prm-adminUserManagementButton', // CSS class for styling
                                    template: function (obj) {
                                        // Template for rendering details icon
                                        return "<span class='webix_icon wxi-close details'></span>";
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for user ID
                                    header: _('ID Usuario'), // Localized header
                                    width: 60,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Login', // Column ID for username
                                    header: _('Usuario'), // Localized header
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'FirstName', // Column ID for first name
                                    header: _('Primer nombre'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'Phone', // Column ID for phone number
                                    header: _('Teléfono'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'LastLoginLocalDate', // Column ID for last login date
                                    header: _('Fecha del ultimo logueo'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'Email', // Column ID for email
                                    header: _('Email'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'IsLocked', // Column ID for user status
                                    header: _('Estado'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                },
                            ],
                            onClick: {
                                details: function (euv, id) {
                                    // Event handler for details click
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.show(
                                        'adminUserManagement?user=' +
                                            item.Id +
                                            '/security.adminuser.informationAdminUser',
                                    ); // Navigate to user management
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the admin user view.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the data table instance
        var url = devConfig.geturlApi() + 'es/UserManagement/GetAdminUser'; // API URL for fetching users
        var vthis = this; // Reference to the current instance
        var filter = ''; // Filter string initialization
        this.on(this.app, 'adminUser:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter string initialization
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filter values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object filter entries
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter string
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id); // Load data based on selected player
        });
    }
}

// FILE DOCUMENTED
